module.exports = __webpack_public_path__ + "img/deepcba.2aac4921.png";